import { Flex, Box, FlexProps, Text } from "@chakra-ui/react";
import Image from "components/Image";

interface Props extends FlexProps {
  imageSrc: StaticImageData;
  title: string | any;
  content: string;
  imageAltText: string;
  isReversed?: boolean;
  spacing?: string;
}

const HomeCard = ({
  imageSrc,
  title,
  imageAltText,
  content,
  isReversed,
  spacing,
  ...props
}: Props) => {
  return (
    <Flex
      flexDir="column"
      align={["center", null, null, null, null, "flex-start"]}
      justify="flex-start"
      maxW={["none", null, null, null, null, "911px"]}
      minH={["unset", null, null, null, null, "343px"]}
      border="none"
      borderRadius="5px"
      {...props}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        m={["0 auto 20px", null, null, null, null, "0 0 43.8px 24px"]}
        height={["auto", null, null, null, null, "204px"]}
      >
        <Image src={imageSrc} alt={imageAltText ?? title} />
      </Box>
      <Flex
        flexDir="column"
      >
        <Text
          fontSize={["1rem", null, null, null, null, "24px"]}
          fontWeight="700"
          lineHeight={["1.25rem", null, null, null, null, "35.3px"]}
          color="black"
          maxW="416px"
          m={["0 auto 15px", null, null, null, null, "0 0 35px"]}
          textAlign={["center", null, null, null, null, "start"]}
        >
          {title}
        </Text>
        <Text
          fontSize={["14px", null, null, null, null, "21px"]}
          fontWeight="300"
          lineHeight={["20px", null, null, null, null, "25.62px"]}
          color="gray"
          textAlign={["center", null, null, null, null, "start"]}
        >
          {content}
        </Text>
      </Flex>
    </Flex>
  );
};

export default HomeCard;
